import React from "react"
import ContUpNumber from "./contUpNumber"
import uuid from "react-uuid"
import TitleStyled from "./styles/titleStyles"
import RowNumbersStyled from "./styles/RowNumbersStyles"

const RowNumbers = ({ heading, numbers }) => {
  return (
    <RowNumbersStyled>
      <div className="container">
        {heading ? (
          <TitleStyled
            textAlign="center"
            linePosition="center"
            color="#000"
            lineColor="#000"
          >
            <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
          </TitleStyled>
        ) : (
          ""
        )}
        <div className={`numbers numbers--${numbers.length}`}>
          {numbers.map(item => (
            <div className="numbers__item" key={uuid()}>
              <p className="numbers__number">
                <ContUpNumber number={item.value.number} />
              </p>
              <p
                className="numbers__description"
                dangerouslySetInnerHTML={{ __html: item.value.heading }}
              ></p>
            </div>
          ))}
        </div>
      </div>
    </RowNumbersStyled>
  )
}

export default RowNumbers
